import { t } from "i18next";
import { useEffect, useState } from "react";

import { MonitorEventByIdResponse } from "../../api/MonitorService";
import MonitorServiceAction from "../../api/MonitorService";
import { MinimalProduct } from "../../types/product";
import { formatServiceData } from "../../utils/formatServiseData";
import { fromMonitorMaterials } from "../../utils/materials";
import { CustomCollapse } from "../CustomCollapse/CustomCollapse";
import { CustomTextArea } from "../CustomTextArea/CustomTextArea";
import { ResourceImages } from "../ResourceImages/ResourceImages";

interface Props {
  event: MonitorEventByIdResponse | undefined;
}

export const NoInfestationDetails = ({ event }: Props) => {
  const { images } = formatServiceData(event);
  const [products, setProducts] = useState<MinimalProduct[]>([]);
  const [date, setDate] = useState("");

  const id = event?.data?.monitorId;
  const jobId = event?.data?.jobId;

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        if (!id || !jobId) {
          return;
        }
        const response = await MonitorServiceAction.GetProducts(
          jobId,
          id
        );
        const allProducts = fromMonitorMaterials(response.data);

        setProducts(allProducts);
        if (allProducts.length !== 0) {
          setDate(response.data.createdAt);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div>
      <ResourceImages images={images} />
      <CustomCollapse products={products} date={date} readOnly={true}>
        Materialeinsatz
      </CustomCollapse>
      <CustomTextArea
        placeholder={t("AdditionalText")}
        defaultValue={event?.data?.comment ?? ""}
        onTextareaChange={() => {}}
        readonly
      />
    </div>
  );
};
